module.exports = __webpack_public_path__ + "img/banner.818df8bd.png";